import React, { useCallback, useRef } from 'react'
import { TtIcon, TtDropdown } from '@23/react'
import { intl } from 'lang/intl'
import { savePanelState } from '../../../../firebase/hooks/usePanel'
import { PanelMenuForm } from './PanelMenuForm'

import './PanelMenuPopOver.scss'

const PanelMenuPopOver = () => {
  const dropdownRef = useRef<HTMLTtDropdownElement>(null)

  const handleSubmit = useCallback(
    async (selectedValues: number[], screen: number | 'tray' | undefined) => {
      dropdownRef.current?.hide()
      await savePanelState(selectedValues, screen)
    },
    []
  )

  const ariaLabel = intl.formatMessage({
    defaultMessage: 'Configure Panel',
  })

  return (
    <TtDropdown
      ref={dropdownRef}
      className="panel-participant-list-popover"
      placement="top-end"
      distance={76}
      skidding={10}
      closeOnSelect={false}
      hoist
    >
      <button
        slot="trigger"
        className="panel-selector-button"
        type="button"
        aria-label={ariaLabel}
      >
        <TtIcon name="cog" library="23" />
      </button>
      <PanelMenuForm onSubmit={handleSubmit} />
    </TtDropdown>
  )
}

export { PanelMenuPopOver }
